import { gql } from 'apollo-angular';

const GET_USER = gql`
  query user($email: String!) {
    user(emailId: $email) {
      id
      firstName
      lastName
      email
      phone
      jobTitle
      timezone
      language
      industry
      status
      roles {
        id
        name
      }
      organization {
        id
        name
        allowedDomains
        companyUrl
        createdBy
        subscription {
          subscriptionId
          status
          currentPeriodStart
          currentPeriodEnd
          customerId
          priceId
          amount
          currency
          interval
          plan {
            id
            name
            stripePlanId
            description
            rate {
              amount
              currency
              interval
            }
            featureQuotaMapping {
              featureId
              quota
              featureKey
}
          }
        }
      }
      account {
        id
        name
      }
    }
  }
`;

const CREATE_USER = gql`
  mutation addUser($user: CreateUserInputType!) {
    addUser(user: $user) {
      firstName
      lastName
      email
      phone
      industry
      jobTitle
      roles {
        id
        name
      } 
      organization {
        id
        name
        subscription {
          subscriptionId
          status
          currentPeriodStart
          currentPeriodEnd
          customerId
          priceId
          amount
          currency
          interval
        }
      }
      account {
        id
        name
      }
    }
  }
`;

const UPDATE_USER = gql`
  mutation updateUser($email: String!, $userData: UpdateUserInput!) {
    updateUser(email: $email, user: $userData) {
      firstName
      lastName
      email
      phone
      industry
      jobTitle
      timezone
      language
    }
  }
`;

export { GET_USER, CREATE_USER, UPDATE_USER, };
